import React from 'react'

export default function Footer() {
  return (
    <div className='pt-[100px] pb-8 flex items-center justify-center'>
        <p className='footer-text text-center text-sm code-font' style={{ color: 'var(--color-muted)' }}>
          made with intent &mdash; haaris iqubal
        </p>
    </div>
  )
}
